export const englishConstants = {
  "general.error.chooseFile.size": "Max File Size is 12MB",
  "dashboard.progress.label": "Compliance",
  "msg.login.page.first.heading": "Your Feedback",
  "alert.msg.department.attribute": "Department Attributes saved successfully",
  "msg.login.page.first.heading": "Your Feedback, ",
  "msg.login.page.sec.heading": " Our Support!",
  "msg.login.page.description":
    "feedback serves as a catalyst for improvement, fostering growth, innovation, and excellence in various aspects of life, whether it's individual performance, teamwork, or the quality of products and services.",
  "msg.prop.project.name": "Turant Upaay",
  "login.welcome.msg": "Hello User!",
  "login.page.title.welcome": "|| Welcome ||",
  "login.askForLogIn.msg": "Please login to Access your Account",
  "general.label.dropdown.email": "Email",
  "general.label.email": "Email Id",
  "general.placeHolder.email": "Enter Email Id",
  "general.label.password": "Password",
  "general.placeHolder.password": "Enter Password",
  "general.label.captcha": "Captcha Code",
  "general.placeHolder.captcha": "Enter captcha code",
  "login.msg.failed": "Your login attempt was not successful, try again.",
  "login.msg.reason": "Reason",
  "login.msg.comment": "Comment",
  "general.label.signin": " Sign In ",
  "general.label.signup": "Sign Up",
  "login.msg.notSignUp": "Don't have an account !",
  "general.label.fromDate": "From Date",
  "general.placeHolder.fromDate": "Please provide From Date",
  "general.label.toDate": "To Date",
  "general.placeHolder.toDate": "Please provide To Date",
  "customer.emailId.empty": "Enter Email Id",
  "customer.mobileNumber.empty": "Enter Phone Number",
  "customer.organizationName.empty": "Enter Organization Name",
  "customer.firstName.empty": "Enter First Name",
  "customer.lastName.empty": "Enter Last Name",
  "customer.description.empty": "Enter Feedback Description",
  "customer.emailId.pattern.missmatch": "Invalid Email Id",
  "menu.key.navigation": "Navigation",
  "menu.key.components": "Components",
  "menu.key.dashboard": "Dashboard",
  "menu.key.master": "Master",
  "menu.key.master.department": "Department",
  "menu.key.master.attribute": "Attribute",
  "menu.key.master.feedbackSource": "Feedback Source",
  "menu.key.feedback": "Feedback",
  "menu.key.quickLog": "Quick Issue Log",
  "menu.key.feedback.add": "Add Feedback",
  "menu.key.callback": "Callback",
  "menu.key.callback.report": "Callback Report",
  "menu.key.report": "Report",
  "menu.key.report.vsd": "VSD Report",
  "menu.key.report.topnpercent": "TopNPercent Report",
  "menu.key.report.branchreport": "Branch Report",
  "menu.key.report.aging": "Aging Report",
  "menu.key.report.mis": "MIS Report",
  "menu.key.report.misrawdump.multi.dept": "MIS Multi Dept Report",
  "menu.key.report.area.of.concern": "Area Of Concern Report",
  "menu.key.report.g8.report": "G8 Reports",
  "menu.key.report.g8.report.key.themes": "Key Themes",
  "menu.key.receipt.add": "Add Receipt",
  "menu.key.feedback.reassignment": "Feedback Reassignment",
  "menu.key.feedback.close": "Close Feedback",
  "menu.key.feedback.close.multiple": "Close Feedbacks",
  "menu.key.feedback.search": "Search Feedback",
  "menu.key.feedback.accept": "Accept Feedback",
  "menu.key.feedback.view": "View Feedback",
  "menu.key.feedback.quicklog": "Feedback Quicklog",
  "menu.key.feedback.reopen": "Reopened Feedback",
  "menu.key.feedback.close.bulkclosure": "Feedback BulkClosure",
  "menu.key.feedback.bulk.resolve": "Bulk Resolve",
  "menu.key.feedback.bulk.close": "Bulk Close",
  "menu.key.rule.add": "Add Rule",
  "menu.key.user": "User",
  "menu.key.user.add": "Add User",
  "menu.key.user.add.external": "Add External User",
  "menu.key.user.add.internal": "Add Internal User",
  "menu.key.user.assigneeGropu": "View Assignee Group",
  "menu.key.user.assigneegroup": "Assignee Group",
  "menu.key.authorization.define": "Define Authorization",
  "menu.key.configuration": "Configuration",
  "menu.key.escalation.matrix": "Escalation Matrix",
  "menu.key.assigneeGrp.header": "Group List",
  "menu.key.master.area": "Master Area",
  "menu.key.sub.area": "Sub Area",
  "menu.key.master.addGroupName": "Add Assignee Group",
  "menu.key.master.modifyGroupName": "Modify Assignee Group",
  "menu.key.master.addGroup": "Add Group",
  "menu.key.master.escMatrix": "Configure Escalation Matrix",
  "title.new.feedbacklist.viewFeedback": "View Feedback List",
  "title.new.feedbacklist.CloseFeedback": "View WIP Feedback List",
  "label.new.feedbacklist.feedbackCdoe": "Feedback Code",
  "label.new.feedbacklist.Description": "Description",
  "label.new.feedbacklist.Organization": "Organization",
  "label.new.feedbacklist.DateOfFeedback": "Date Of Feedback",
  "label.new.feedbacklist.phoneAndMobileNo": "Mob No. & Ph No.",
  "label.new.feedbacklist.Status": "Status",
  "label.new.feedbacklist.Action": "Action",
  "label.new.feedbacklist.SLNo": "Sl No",
  "label.new.feedbacklist.select": "select multiple",
  "FILE.UPLOAD.PATH.CLOSE.FEEDBACK": "D:\\\\feedback\\\\close\\\\",
  "LdapAuthenticationProvider.badCredentials":
    "Username/Password entered is incorrect",
  "AbstractUserDetailsAuthenticationProvider.badCredentials":
    "The credentials you supplied are invalid/locked/expired",
  "AbstractUserDetailsAuthenticationProvider.internalAuthenticationServiceException.other":
    "Invalid Username/Password found, please provide correct credentials",
  "AbstractUserDetailsAuthenticationProvider.internalAuthenticationServiceException.exceededAllowed":
    "Maximum sessions of {0} for this principal exceeded",
  "PasswordComparisonAuthenticator.badCredentials": "Wrong password",
  "ConcurrentSessionControlAuthenticationStrategy.exceededAllowed":
    "Maximum sessions of {0} for this user exceeded",
  "error.captcha.blank": "Captcha is blank",
  "error.captcha.invalid": "Invalid Captcha",
  "label.general.navigation.youAreHere": "YOU ARE HERE",
  "label.general.navigation.home": "Home",
  "label.addUser.page.title": "Add New User",
  "label.addUser.pageHeader": "Add User",
  "label.addUser.navigation.User": "User",
  "label.addUser.panelHeader": "Add new user information",
  "label.addUser.userForm.field.fullName.label": "Full Name",
  "label.addUser.message.success": "User created successfully.",
  "label.addUser.message.fail": "User not created due to some internal error !",
  "label.addUser.message.invalidInput":
    "Provided user information are not valid.",
  "label.new.addFeedbackSource": "Add Feedback Source",
  "label.new.addMasterArea": "Add Master Area",
  "label.new.addSubArea": "Add Sub Area",
  "label.new.addGroup": "Add Group Name",
  "label.new.addGroup.group": "ADD GROUP",
  "general.footer.label.copyRight": "© 2026 mjunction services limited.",
  "general.footer.label.version": "Version 5.0",
  "general.field.firstName.label": "First Name",
  "general.field.firstName.placeHolder": "Enter first name here",
  "general.field.firstName.validation.notEmpty":
    "First name should not be empty for user",
  "general.field.lastName.label": "Last Name",
  "general.field.lastName.placeHolder": "Enter last name here",
  "general.field.lastName.validation.notEmpty":
    "Last name should not be empty for user",
  "general.field.email.label": "Email Address",
  "general.field.email.placeHolder": "Enter email here",
  "general.field.email.validation.notEmpty":
    "Email address is mandatory & can't be empty",
  "general.field.email.validation.invalidEmail":
    "Provided Email id is not valid",
  "general.field.email.validation.mjEmail":
    "mjunction email can't be used to create user",
  "general.field.email.validation.alreadyExistEmail":
    "User already exist in CCHP data base",
  "general.field.password.label": "Password",
  "general.field.password.placeHolder": "Enter password here",
  "general.field.password.hint.text":
    "Password must be between 6 and 15 characters, with at least one digit and one alphabetic lower character and one alphabetic upper character and one special character",
  "general.field.password.validation.notEmpty":
    "Password is mandatory & can't be empty",
  "general.field.password.validation.invalidPassword":
    "The input is not a valid password",
  "general.field.password.validation.limit.min":
    "Password must be more than 8 characters long",
  "general.field.password.validation.limit.max":
    "Password must not be more than 15 characters long",
  "general.field.password.validation.charachter.lower":
    "Password must contain at least one lower case character",
  "general.field.password.validation.charachter.upper":
    "Password must contain at least one upper case character",
  "general.field.password.validation.charachter.digit":
    "Password must contain at least one digit",
  "general.field.password.validation.charachter.special":
    "Password must contain at least one special character from '@#$%^+='",
  "general.field.confirmPassword.label": "Retype Password",
  "general.field.confirmPassword.placeHolder":
    "Please retype the password here",
  "general.field.confirmPassword.validation.notEmpty":
    "Confirm of password is mandatory & can't be empty",
  "general.field.confirmPassword.validation.identicalToPassword":
    "The password and its confirmation text are not the same",
  "general.field.mobile.label": "Mobile Number",
  "general.field.mobile.placeHolder": "Enter mobile number(9999999999) here",
  "general.field.mobile.hint": "9999999999",
  "general.field.mobile.validation.notEmpty":
    "Mobile number is mandatory & can't be empty",
  "general.field.mobile.validation.invalidMobile": "Mobile number is invalid",
  "general.field.phone.label": "Phone Number",
  "general.field.phone.placeHolder": "Enter phone number(8-12 digits) here",
  "general.field.phone.hint": "8-12 digits",
  "general.field.phone.validation.notEmpty":
    "Phone number is mandatory & can't be empty",
  "general.field.phone.validation.invalidPhone": "Phone number is invalid",
  "general.field.addressLine.label": "Address Line",
  "general.field.addressLine.placeHolder": "Please type in the address here",
  "general.field.addressLine.validation.notEmpty":
    "Address Line is mandatory & can't be empty",
  "general.field.addressLine.validation.sizeLimit.LT1000":
    "The address line must be less than 1000 characters long",
  "general.message.checkInputBeforeSubmit":
    "Please check all the inputs properly before submitting the data !",
  "general.message.checkInputBeforeDownload":
    "Please check all the inputs properly before downloading",
  "general.message.errorFetchingData":
    "Error occurred during fetching of data !",
  "general.message.panel.heading.msg": "Message",
  "general.button.panel.footer.close": "Close",
  "general.button.reset.label": "Reset",
  "general.button.submit.label": "Submit",
  "general.button.view.report.label": "View Report",
  "general.button.download.pdf.report.label": "Download PDF",
  "general.button.download.excel.report.label": "Download Excel",
  "general.tooltip.charachter.limit.remaining": "character(s) remaining",
  "general.tooltip.charachter.limit.moreThan": "More than",
  "general.tooltip.charachter.limit.chUnacceptable":
    "characters are unacceptable",
  "general.message.select.label": "Select",
  "general.message.notApplicable.label": "N/A",
  "label.defineAuthorization.page.title": "Define Authorization",
  "label.defineAuthorization.pageHeader": "Define Authorization",
  "label.defineAuthorization.navigation.authorization": "Authorization",
  "label.defineAuthorization.userListPanelHeader": "Select user from the list",
  "label.defineAuthorization.panelHeader": "Grant Authorization",
  "label.defineAuthorization.selectRole.label": "Select Role",
  "label.defineAuthorization.saveRoleConfPrefix.msg":
    "Are you sure you want to give",
  "label.defineAuthorization.saveRoleConfSufix.msg": "following role(s)?",
  "label.defineAuthorization.saveRoleSuccess.msg":
    "User has been granted designated role(s) successfully.",
  "label.defineAuthorization.saveRoleFailure.msg":
    "User has not been granted designated role(s) successfully due to some internal error.",
  "label.defineAuthorization.message.invalidInput":
    "Provided user-role information are not valid.",
  "label.defineAuthorization.title.add-more-auth": "Add more authorities",
  "label.defineAuthorization.title.remove-this-auth": "Remove this authority",
  "label.defineAuthorization.error.role.requered": "Please choose role",
  "label.defineAuthorization.error.department.requered":
    "Please choose department",
  "label.defineAuthorization.error.duplicate.row.partOne":
    "You have already chosen",
  "label.defineAuthorization.error.duplicate.row.partTwo": "role for",
  "label.defineAuthorization.error.duplicate.row.partThree":
    "department previously !",
  "general.datatable.sEmptyTable.label": "No data available in table",
  "general.datatable.sInfo.label":
    "Showing _START_ to _END_ of _TOTAL_ entries",
  "general.datatable.sInfoEmpty.label": "Showing 0 to 0 of 0 entries",
  "general.datatable.sInfoFiltered.label":
    "(filtered from _MAX_ total entries)",
  "general.datatable.sInfoPostFix.label": "",
  "general.datatable.sInfoThousands.label": ",",
  "general.datatable.sLengthMenu.label": "Show _MENU_ entries",
  "general.datatable.sLoadingRecords.label": "Loading...",
  "general.datatable.sProcessing.label": "Processing...",
  "general.datatable.sSearch.label": "Search:",
  "general.datatable.sort.by": "Sort by:",
  "general.datatable.sZeroRecords.label": "No matching records found",
  "general.datatable.sFirst.label": "First",
  "general.datatable.sLast.label": "Last",
  "general.datatable.sNext.label": "Next",
  "general.datatable.sPrevious.label": "Previous",
  "general.datatable.sSortAscending.label":
    ": activate to sort column ascending",
  "general.datatable.sSortDescending.label":
    ": activate to sort column descending",
  "general.button.yes.label": "Yes",
  "general.button.no.label": "No",
  "general.button.ok.label": "OK",
  "general.button.update.label": "Update User",
  "general.button.cancel.label": "Cancel",
  "general.closefeedbackEmpty.lebel":
    "Please select at least one feedback to close",
  "general.closeFeedbackSuccess.level": "Feedback successfully closed",
  "general.closeFeedbackFailure.level": "Feedbacks close failed",
  "user.role.admin.label": "Admin",
  "user.role.buHead.label": "BU Head",
  "user.role.buManager.label": "VP/HEAD",
  "user.role.customerSupport.label": "Customer Support",
  "user.role.escalationMatrixUser.label": "Escalation Matrix User",
  "user.role.spoc.label": "SPOC",
  "user.role.resolver.label": "Resolver",
  "user.role.callCenterPersonnel.label": "Call Center Personnel",
  "user.role.employee.label": "Employee",
  "user.role.customer.label": "Customer",
  "user.role.vp.head.label": "ROLE_VP/HEAD",
  "user.role.client.label": "ROLE_CLIENT",
  "user.role.client2.label": "ROLE_CLIENT2",
  "user.role.client3.label": "ROLE_CLIENT3",
  "user.department.select.label": "Select Department",
  "user.info.general.invalid.info.errMsg":
    "Provided user information found invalid.",
  "user.info.role.notFound.errMsg": "User role information not found.",
  "user.info.department.notFound.errMsg":
    "User department information not found.",
  "general.msg.credential.undefined": "Credential Undefined.",
  "general.msg.credential.changed.success":
    "Password changed successfully. Please log-in using your new password.",
  "general.field.password.old.label": "Old Password",
  "general.field.password.old.placeHolder":
    "Please enter your old password here",
  "general.field.password.old.validation.notEmpty":
    "Old password is mandatory & can't be left blank.",
  "general.field.password.new.label": "New Password",
  "general.field.password.new.placeHolder":
    "Please enter your new password here",
  "general.field.password.new.validation.notEmpty":
    "New password is mandatory & can't be left blank.",
  "general.field.password.validation.sameAsOldPassword":
    "Both the old and new passwords are same",
  "general.field.password.validation.invalidOldPassword":
    "Wrong old password entered",
  "page.reset.password.heading": "Please reset your password below",
  "page.reset.password.button.restpwd": "Reset Password",
  "page.reset.password.buttom.msg":
    "***Please note, if you are viewing this page, it means either you are a first time user or your password got expired !",
  "page.reset.password.error.internal":
    "Password reset failed due to some internal error, please try again !",
  "general.dialog.label.sessionExpired": "Session Expired",
  "general.dialog.title.sessionExpired": "Session Expiring soon",
  "general.dialog.msg.sessionExpired": "Your session is about to expire.",
  "general.dialog.button.label.logoutNow": "Logout Now",
  "general.dialog.button.label.stayConnected": "Stay Connected",
  "general.dialog.title.autoLogOut":
    "You are being redirecting to login page...",
  "general.dialog.title.multiSignDecision": "Please choose your preference...",
  "general.page.sessionExpired.msgH5":
    "Your session got expired, redirecting to the login page in 5 seconds...",
  "report.page.aging.table.header.feedbacktype": "Feedback Type",
  "report.page.aging.table.header.area": "Master Area",
  "report.page.aging.table.header.subarea": "Sub Area",
  "report.page.aging.table.header.priority": "Priority",
  "report.page.rpt.table.header.loggersCompany": "Logger's Company",
  "report.page.aging.table.header.days": "Days",
  "report.page.aging.table.header.grandTotal": "Grand Total",
  "report.aging.error.msg.date.minimum.bucketsize":
    "From and To dates should be at least {0} days away",
  "report.aging.error.msg.date.minimum.days":
    "From and To dates should be at least {0} days away",
  "report.aging.error.msg.date.maximum.days":
    "From and To dates should be at most {0} days away",
  "report.aging.error.msg.date.maximum.month":
    "From and To dates should be at most {0} months away",
  "report.aging.warning.msg.date.minmax.days":
    "***Date range should be selected minimum of 30 and maximum of 90 days",
  "report.aging.error.msg.noRecords":
    "No records found for the given criteria.",
  "report.aging.error.msg.general":
    "Error occurred during the generation of report. Please check your given inputs or contact system administrator.",
  "report.aging.error.department.requered": "Please select department",
  "report.aging.error.fromDate.requered": "The from date is required",
  "report.aging.error.fromDate.invalid": "The from date is not valid",
  "report.aging.error.endDateLessThanStartDate":
    "Please make sure that the end Date is after the start Date.",
  "report.aging.error.toDate.requered": "The to date is required",
  "report.aging.error.toDate.invalid": "The end date is not valid",
  "report.aging.error.reportType.requered":
    "Please select desired report type.",
  "report.aging.page.header.from.details": "Aging Details",
  "report.aging.label.selectReportType": "Select Report Type",
  "report.aging.reportType.msg.RegisteredANDAssignedToGroup":
    "Registered - Assigned To Group",
  "report.aging.reportType.msg.AssignedToGroupANDPickedUp":
    "Assigned To Group - Open",
  "report.aging.reportType.msg.PickedUpANDResolve": "Opened - Resolve",
  "report.aging.reportType.msg.ResolvedANDClose": "Resolved - Close",
  "report.aging.helpText.msg.RegisteredANDAssignedToGroup":
    '***For the report type \\"Registered - Assigned To Group\\" the selected feedbacks were resigtered withing the provided date range and current status is Assigned to group',
  "report.aging.helpText.msg.AssignedToGroupANDPickedUp":
    '***For the report type \\"Assigned To Group - Open\\" the selected feedbacks were assigned to group withing the provided date range and current status is opened',
  "report.aging.helpText.msg.PickedUpANDResolve":
    '***For the report type \\"Opened - Resolve\\" the selected feedbacks were picked up withing the provided date range and current status is resolved',
  "report.aging.helpText.msg.ResolvedANDClose":
    '***For the report type \\"Resolved - Close\\" the selected feedbacks were resolved withing the provided date range and current status is close',
  "report.mis.page.header.from.details": "MIS Details",
  "report.mis.label.selectMonth": "Select Month",
  "report.type.label.misMonthly": "Complaint Management Dashboard",
  "report.type.label.misTopReasons": "Top Reasons",
  "report.type.label.misTopRepeatReasons": "Top Repeat Reasons",
  "report.type.label.misVOC": "Customer VOC",
  "report.type.label.repeatPercentage": "Repeat Percentage",
  "report.type.label.rawDump": "CCHP MIS",
  "report.mis.label.combined": "Combined",
  "report.mis.warning.msg.date.minmax.days":
    "***Date range should be selected minimum of 16 and maximum of 90 days for Complaint Management Dashboard report",
  "report.mis.rawDump.warning.msg.date.minmax.days":
    "***Date range should be selected minimum of 1 day and maximum of 3 months for CCHP MIS report",
  "report.mis.multi.dept.error.department.required": "Select at least one department",
  "report.mis.multi.dept.error.invalid.dates": "Please provide valid date(s)",
  "report.mis.multi.dept.error.from.before.to":
    "From Date should be earlier than To Date by at least 1 day",
  "report.mis.multi.dept.error.download.failed": "Failed to download MIS Multi Dept report",
  "report.mis.multi.dept.label.isResolved": "Resolved",
  "report.mis.multi.dept.isResolved.all": "All",
  "report.mis.multi.dept.isResolved.yes": "Resolved",
  "report.mis.multi.dept.isResolved.no": "Not Resolved",
  "report.mis.column.label.raised": "Raised",
  "report.mis.column.label.openWithinSla": "Open Within Sla",
  "report.mis.column.label.openOutOfSla": "Open Out Of Sla",
  "report.mis.column.label.openWithCSWithinSla": "Open With CS Within SLA",
  "report.mis.column.label.openWithCSOutOfSla": "Open With CS Out Of SLA",
  "report.mis.column.label.totalClosed": "Total Closed",
  "report.mis.column.label.closedWithinSla": "Closed Within SLA",
  "report.mis.column.label.closedOutOfSla": "Closed Out Of SLA",
  "report.mis.column.label.reopenedWithBUWithinSla":
    "Reopened With BU Within SLA",
  "report.mis.column.label.reopenedWithBUOutOfSla":
    "Reopened With BU Out Of SLA",
  "report.mis.column.label.reopenedWithCSWithinSla":
    "Reopened With CS Within SLA",
  "report.mis.column.label.reopenedWithCSOutOfSla":
    "Reopened With CS Out Of SLA",
  "report.mis.column.label.totalReopenedAndClosed": "Total Reopened And Closed",
  "report.mis.column.label.reopenedAndClosedWithinSla":
    "Reopened And Closed Within SLA",
  "report.mis.column.label.reopenedAndClosedOutOfSla":
    "Reopened And Closed Out Of SLA",
  "report.mis.column.label.slaPercentage": "SLA %",
  "report.mis.column.label.contributionOnTotalVolPercent":
    "Contribution On Total Vol %",
  "report.mis.label.reportMonths": "Report Months",
  "report.mis.label.months": "Months",
  "report.mis.placeHolder.reportMonths": "Choose report months",
  "report.mis.error.reportMonths.requered": "Report months are required",
  "report.mis.error.reportMonths.2to3Options":
    "Please select 2-3 report months at a time",
  "report.mis.error.reportMonths.consecutive":
    "Please select consecutive months to generate report",
  "report.mis.column.label.notSatisfiedPercentage": "% of Not Satisfied",
  "report.mis.column.label.repeatPercentage.fType.complaints": "COMPLAINTS",
  "report.mis.column.label.repeatPercentage.fType.rest":
    "REST (other than Complaints)",
  "report.mis.column.label.repeatPercentage.fType.overall": "Overall",
  "report.mis.column.label.repeatPercentage.months.totalPeriod":
    "Total (Current Period + Previous Same Period)",
  "report.mis.column.label.repeatPercentage.months.repeats":
    "Repeats (Current Period + Previous Same Period)",
  "report.mis.column.label.repeatPercentage.months.repeatPeriod":
    "Repeat %  w.r.t. No. of CCHP tags against a Single Customer (more than 1) for a particular Client - Master Area & Sub Area during Rolling Periods (for eg. Rolling {0} days = {1}days of Current Period + {2}days of Previous Same Period)",
  "report.mis.column.label.repeatPercentage.months.total": "Total",
  "report.mis.column.label.rawDump.bu": "BU",
  "report.mis.column.label.rawDump.feedbackDate": "Feedback Date",
  "report.mis.column.label.rawDump.spocName": "Spoc Name",
  "report.mis.column.label.rawDump.feedbackAssignmentTime":
    "Feedback Assignment Time",
  "report.mis.column.label.rawDump.assignmentDuration": "Assignment Duration",
  "report.mis.column.label.rawDump.loggerName": "Logger Name",
  "report.mis.column.label.rawDump.loggerMobile": "Logger Mobile",
  "report.mis.column.label.rawDump.loggerPhone": "Logger Phone",
  "report.mis.column.label.rawDump.loggerType": "Logger Type",
  "report.mis.column.label.rawDump.loggerId": "Logger Id",
  "report.mis.column.label.rawDump.buUserId": "BU User Id",
  "report.mis.column.label.rawDump.vendorcode": "Vendor Code/Client Id",
  "report.mis.column.label.rawDump.feedbackCreatorName":
    "Feedback Creator Name",
  "report.mis.column.label.rawDump.pickedUpTime": "Picked Up Time",
  "report.mis.column.label.rawDump.pickedUpDuration": "Pickup Duration",
  "report.mis.column.label.rawDump.resolutionDate": "Resolver Resolution Date",
  "report.mis.column.label.rawDump.resolverRemarks": "Resolver Remarks",
  "report.mis.column.label.rawDump.escalatedToFirstLevel":
    "Escalated To First Level",
  "report.mis.column.label.rawDump.firstLevelEscalationTime":
    "First Level Escalation Time",
  "report.mis.column.label.rawDump.escalatedToSecondLevel":
    "Escalated To Second Level",
  "report.mis.column.label.rawDump.secondLevelEscalationTime":
    "Second Level Escalation Time",
  "report.mis.column.label.rawDump.escalatedToThirdLevel":
    "Escalated To Third Level",
  "report.mis.column.label.rawDump.thirdLevelEscalationTime":
    "Third Level Escalation Time",
  "report.mis.column.label.rawDump.assignmentEscalationStatus":
    "Assignment Escalation Status",
  "report.mis.column.label.rawDump.pickupEscalationStatus":
    "Pickup Escalation Status",
  "report.mis.column.label.rawDump.closureEscalationStatus":
    "Closure Escalation Status",
  "report.mis.column.label.rawDump.sLADuration24By7Frame":
    "BU Closure SLA Duration (24/7 frame)",
  "report.mis.column.label.rawDump.feedbackPendingWith":
    "Feedback Pending With",
  "report.mis.column.label.rawDump.customerConsentComment":
    "Customer Consent Comment",
  "report.mis.column.label.rawDump.closingDate": "Closing Date",
  "report.mis.column.label.rawDump.isEscalatedFeedback": "Escalated",
  "report.mis.column.label.rawDump.firstEscalationDate": "1st Esc Dt/Time",
  "report.mis.column.label.rawDump.assignmentTarget": "Assignment Target Time",
  "report.mis.column.label.rawDump.pickupTarget": "Pickup Target Time",
  "report.mis.column.label.rawDump.closureTarget": "Closure Target Time",
  "general.label.status.new": "New",
  "general.label.status.unassigned": "Unassigned",
  "general.label.status.assign": "Assign",
  "general.label.status.assigned": "Assigned",
  "general.label.status.open": "Open",
  "general.label.status.opened": "Opened",
  "general.label.status.reopen": "Reopen",
  "general.label.status.reopened": "Reopened",
  "general.label.status.resolve": "Resolve",
  "general.label.status.resolved": "Resolved",
  "general.label.status.close": "Close",
  "general.label.status.closed": "Closed",
  "general.label.status.atg": "Assigned to group",
  "general.label.total": "Total",
  "general.button.filterMore.text": "More Filter",
  "general.button.filterLess.text": "Less Filter",
  "general.label.feedbackStatus.text": "Feedback Status",
  "general.lable.select.feedbackStatus.text": "Select Feedback Status",
  "general.lable.feedbackType.text": "Feedback Type",
  "general.lable.select.feedbackType.text": "Select Feedback Type",
  "general.lable.select.masterArea.text": "Select Master Area",
  "general.lable.select.subArea.text": "Select Sub Area",
  "general.lable.select.feedbackSource.text": "Select Feedback Source",
  "general.lable.select.groupType.text": "Select Assignee Group Type",
  "general.lable.table.select.groupType.text": "Assignee Group Type",
  "general.lable.bidderOrg.text": "Bidder Organization",
  "general.lable.username.text": "User Name",
  "general.lable.bidderId.text": "Bidder Id",
  "general.lable.panNo.text": "PAN No",
  "general.lable.vendorCode.text": "Vendor Code",
  "general.button.view.text": "View",
  "general.button.edit.text": "Edit",
  "general.button.search.text": "Search",
  "general.error.fromDate.required": "Please Enter From Date",
  "general.error.toDate.required": "Please Enter To Date",
  "general.error.feedbackStatus.required": "Please Select Feedback Status",
  "general.error.fromDateNotGreater.required":
    "From Date can not be greater than To Date",
  "general.msg.logout.text": "Logout",
  "general.lable.feedbackDetail.text": "Feedback Details",
  "general.tab.feedbackDetails.text": "Feedback Details",
  "general.tab.assigneeGrp.details": "Details(Add/Edit)",
  "general.tab.commentDetails.text": "Comment Details",
  "general.tab.generate.new.report": "Generate New Report",
  "general.tab.area.of.concern.type": "Select Area Of Concern Type",
  "general.tab.area.of.concern.type.reports": "Area Of Concern Type",
  "general.tab.area.of.concern.top.count": "Select Top Count",
  "general.tab.area.of.concern.top.count.table": "Select Top Count For Table",
  "general.tab.area.of.concern.top.count.visualization": "Select Top Count For Visualization",
  "general.tab.receiptDetails.text": "Receipt Details",
  "general.tab.markDiscarded.text": "Mark Discarded",
  "general.tab.resolutionDetails.text": "Resolution Details",
  "general.tab.slaDetails.text": "SLA Details",
  "general.tab.customerSatisfaction.text": "Customer Satisfaction",
  "feedback.dropdown.viewFeedback.label": "entries",
  "feedback.dropdown.viewFeedback.show": "Show",
  "feedback.viewFeedback.searchbar": "Search here...",
  "feedback.viewFeedback.rowsPerPage": "Rows per page",
  "feedbackDetails.currentStatus.text": "Current Status",
  "Feedback Details": "feedback D",
  "feedbackDetails.organizationName.text": "Organization Name",
  "feedbackDetails.feedbackDescription.text": "Feedback Description",
  "feedbackDetails.feedbackGiven.text": "Feedback Given By",
  "feedbackDetails.address.text": "Address",
  "feedbackDetails.createdBy.text": "Created By",
  "feedbackDetails.plantCode.text": "PlantCode",
  "feedbackDetails.taggedFeedbackList.text": "Tagged Feedback List",
  "feedbackDetails.receiver.text": "Receiver",
  "feedbackDetails.targetCompilationDate.text":
    "Target Completion Date(DD-MM-YYYY HH:MM)",
  "feedbackDetails.actualCloseDate.text":
    "Actual Closing Date(DD-MM-YYYY HH:MM)",
  "feedbackDetails.assignedTo.text": "Assigned To",
  "feedbackDetails.comment.text": "Comment",
  "feedbackDetails.resolverName.text": "Resolver Name",
  "feedbackDetails.rootCause.text": "Root Cause",
  "feedbackDetails.correctiveAction.text": "Corrective Action",
  "feedbackDetails.preventiveAction.text": "Preventive Action",
  "feedbackDetails.responseToLogger.text": "Response To Customer",
  "general.error.rootCauseSize.maxLength" : "(Max Length : 1500 Character)",
  "feedbackDetails.completionDate.text": "Date Of Completion",
  "feedbackDetails.autoClosureDate.text": "Auto Closure Date",
  "feedbackDetails.reopenReason.text": "Reopen/Unsatisfied Reason",
  "feedbackDetails.resolutionTarget.text": "Resolution Target",
  "feedbackDetails.step.text": "Step",
  "feedbackDetails.assignName.text": "ASSIGNEE NAME",
  "feedbackDetails.targetTime.text": "Target Time",
  "feedbackDetails.escalationMatrix.text": "Resolution Escalation Matrix",
  "feedbackDetails.level.text": "Level",
  "feedbackDetails.groupName.text": "Group Name",
  "feedbackDetails.escalationTime.text": "Escalation Time",
  "feedbackDetails.feedbackCode.text": "feedback code",
  "bulk.resolve.feedbackCode.text": "Feedback Code",
  "bulk.resolve.feedbackDescription.text": "Feedback Description",
  "feedbackDetails.receiptView.text": "You are viewing",
  "feedbackDetails.satisfactionView.text":
    "You are viewing satisfaction level against",
  "general.label.feedback.satisfaction":
    "Thank you for submitting your feedback satisfaction",
  "feedbackDetails.commentView.text": "You are commenting against",
  "feedbackDetails.reopenReassignView.text": "You are doing reopen & reassign",
  "feedbackDetails.slaView.text": "You are viewing SLA against",
  "general.lable.timeLine.text": "Timeline",
  "general.button.provideConsent.text": "Provide Consent",
  "general.checkbox.addConsent.text": "Add Consent",
  "general.lable.consentUser.text": "Consent User",
  "general.lable.customerResponse.text": "Customer Response",
  "general.select.selectConsent.text": "Select Consent",
  "general.lable.consent.text": "Consent",
  "general.notification.body": "Consent required for feedback",
  "general.date.duration.postfix": "ago",
  "general.button.reopenReassign.text": "REOPEN & REASSIGN",
  "general.lable.satisfactionLevel.text": "Satisfaction Level",
  "general.lable.unsatisfactionReason.text": "Reason",
  "general.lable.untag.reason": "Please add your reason",
  "general.lable.otherReason.text": "Comment",
  "general.lable.otherReason.limitedtext": "Other Reason(upto 5000 character)",
  "general.label.resolver.noData": "No response to customer available now!",
  "general.lable.otherComment.text": "Other Comment",
  "general.select.satisfactionLevel.text": "Select Satisfaction Level",
  "general.select.satisfactionReason.textForStar":
    "Satisfaction Level(**Rating 1 to 3 consider as Not satisfied hence comment/reason required )",
  "general.select.selectUser.text": "Select User",
  "general.lable.userList.text": "User List",
  "general.error.comment.required": "Enter your comment",
  "general.error.consent.required": "Your consent here...",
  "general.error.reason.required": "Reason/Error",
  "general.lable.monthOfFeedback.text": "Month & Year Of Feedback",
  "general.lable.closeFeedbackDate.text": "Close Date Of Feedback",
  "general.lable.reopendFeedbackDate.text": "Date Of Reopen",
  "general.lable.loggedOn.text": "Logged On",
  "general.lable.recentFeedbacks.text": "Recent Feedbacks",
  "general.lable.myTasks.text": "Rate Our Response",
  "general.lable.latestEvents.text": "Latest Events",
  "general.lable.performanceChart.text": "Performance Chart",
  "general.lable.avgResolutionTime.text": "Average Resolution Time",
  "general.button.searchMore.text": "Search more ...",
  "general.chart.legend.issueRaised": "No Of Issue Raised",
  "general.chart.legend.issueResolved": "No Of Issue Resolved",
  "general.chart.area.defaultMessage": "Nothing to show now!",
  "general.chart.area.noTask": "No response available now!",
  "general.chart.area.latestEvent": "No Latest events/Loyalty Offers found!",
  "general.chart.legend.complaint": "Complaint",
  "general.chart.legend.others": "Others",
  "general.chart.legend.other": "Other",
  "general.badge.registered": "Registered",
  "general.badge.workInProgress": "Work In Progress",
  "general.lable.status.showAll": "Show all",
  "general.button.closure": "Rate us",
  "general.model.lable.tryToLog": "You are trying to log a",
  "general.model.lable.isNotComplaint":
    "Feedback(Query/Suggestion/Request/Others)",
  "general.model.lable.or": "Or",
  "general.model.lable.isComplaint": "Complaint",
  "general.model.lable.header.searchC": "Search Criteria",
  "general.model.lable.header.Client": "Client/Plant",
  "general.model.lable.header.Area.subarea": "Area :: Sub Area",
  "gereral.model.lable.header.responseLogger": "Response To Logger",
  "general.model.lable.searchCriteria": "Please select search criteria",
  "general.model.lable.searchCriteriaCustomer":
    "Type minimum 3 characters to search customer",
  "general.model.lable.client": "Please select client/plant",
  "general.model.lable.feedbackDesc": "Type feedback description",
  "general.model.lable.subArea": "Please select sub area",
  "general.model.lable.responseLogger": "Please enter response to logger",
  "general.model.button.continue": "Continue",
  "general.lebel.tagOldFeedback": "Tag Old Feedback",
  "general.button.upload": "Upload",
  "general.button.uploadFile": "Upload File",
  "general.label.client": "Client",
  "general.lable.eventDate": "Event Date",
  "general.select.clientSelect": "Select Client",
  "general.select.birthDate": "Birth Date",
  "general.select.anniversary": "Anniversary",
  "general.place-holder.select.list": "Please select",
  "general.place-holder.date": "Click to select date",
  "general.place-holder.input": "Please provide your input here",
  "general.place-holder.comment": "please provide your comment",
  "general.error.client.required": "Please select client",
  "general.error.event.required": "Please select event date",
  "general.error.feedbackType.required": "Please select feedback type",
  "general.error.chooseFile.required": "Please choose a file",
  "general.error.choosePdfFile.required": "Please choose PDF file",
  "general.error.correctFileFormat.required":
    "Please select correct file format",
  "general.error.greaterFileSize.required":
    "File size is greater than 5MB. Please choose smaller file",
  "general.error.shortFeedbackDescription.required":
    "Use shorter feedback description.",
  "general.error.feedbackDescriptionSize.required":
    "Your feedback description text size is too long.",
  "general.error.failAddFeedback.required": "Fail to add feedback",
  "general.success.feedback.msg": "Feedback is added successfully",
  "general.lable.feedbackCodeIs": "Your feedback code is",
  "general.error.noteDownFeedback":
    "Note down feedback code for future communication",
  "general.label.feedbackdropdown": "Communication gap",
  "general.label.myAssignment": "My Assignments",
  "general.chart.slaStatus": "SLA Status",
  "general.chart.feedbackByStatus": "Feedback by Status",
  "general.button.moreClick": "For More Click Here",
  "general.frontBox.newFeedback": "New Feedback",
  "general.frontBox.slaViolation": "SLA Violation",
  "general.frontBox.pickingViolation": "Acceptance Violation",
  "general.label.noDataFound": "No Data Found",
  "general.label.from": "From",
  "general.label.feedback.createdOn": "Created on",
  "general.label.feedback.created": "Created",
  "general.label.timeElapsed": "Time Elapsed",
  "general.label.slaDate": "SLA Date",
  "general.label.remainingTime": "Remaining Time",
  "general.label.slaOver": "SLA Over",
  "general.label.assignedFeedback": "Assigned Feedback",
  "general.label.acceptedFeedback": "Accepted Feedback",
  "general.label.viewAsignedFeedback": "View Assigned Feedback List",
  "general.label.viewAcceptedFeedback": "View Accepted Feedback List",
  "general.label.quickIssueAcceptedFeedback1":
    "Feedback has been added successfully",
  "general.label.quickIssueAcceptedFeedback2":
    "Please note down feedback code ",
  "general.label.quickIssueAcceptedFeedback3": " for further communication",
  "general.label.nameOrGroup": "NAME/GROUP NAME",
  "general.label.proceedText":
    "Please click on Proceed button to accept the receipt",
  "accept.prompt.proceed.yesno": "Do you wish to continue ?",
  "general.button.proceed": "Proceed",
  "general.lable.confirmMessage": "Please confirm the following",
  "general.lable.resolutionTargetTime": "Resolution Target Time",
  "general.button.accept": "I Accept",
  "general.button.edit.hover.text": "Edit this Escalation Matrix",
  "general.button.resolverGrp.hover.text": "Resolver Group",
  "general.button.escalationLevel.hover.text": "Escalation Level",
  "general.button.add.text": "Add a Escalation Matrix row",
  "general.button.update.hover.text": "Update this user",
  "general.button.remove.hover.text": "Remove this user",
  "general.button.add.hover.text": "Add new user",
  "general.button.view.hover.text": "View Details",
  "general.button.remove.text": "Remove this Escalation Matrix row",
  "general.lable.noUserFound": "No user found for this group",
  "general.error.groupWiseUserListError":
    "Error occurred while fetching group wise user list",
  "general.label.msg.addReceipt":
    "Feedback has been assigned to group successfully",
  "general.label.msg.addReceiptError": "Receipt has not been accepted",
  "general.label.msg.addReceiptSuccess":
    "You have accepted this receipt successfully",
  "general.label.msg.acceptingError": "Error occurred while accepting feedback",
  "general.lable.msg.noAssignmentSla": "No Assignment SLA found",
  "general.lable.msg.noEscalationFound": "No Escalation Details found",
  "general.lable.acceptReceipt": "Please accept within",
  "general.lable.acceptReceiptTime": "seconds",
  "general.error.addReceiptError":
    "Error occurred during receipt add and close",
  "general.lable.feedbackClosure": "FEEDBACK CLOSURE",
  "general.lable.contentHere": "Your content here",
  "general.error.responseToLogger.required":
    "Please provide Response to customer",
  "general.error.rootCause.required": "Please provide Root Cause",
  "general.error.correctiveAction.required": "Please provide Corrective Action",
  "general.error.preventiveAction.required": "Please provide Preventive Action",
  "general.error.preventiveActionSize.required":
    "Please provide Preventive Action within 1500 characters",
  "general.error.correctiveActionSize.required":
    "Please provide Corrective Action within 1500 characters",
  "general.error.rootCauseSize.required":
    "Please provide Root Cause within 1500 characters",
  "general.error.responseToLoggerSize.required":
    "Response to customer is too long",
  "general.label.richTextEditortext": "Response To Customer ",
  "general.lable.slaViolatedFeedback": "SLA Violated Feedback",
  "general.lable.pickingViolatedFeedback": "Picking Violated Feedback",
  "general.lable.slaViolatedFeedbackList": "View SLA Violated Feedback List",
  "general.lable.pickingViolatedFeedbackList":
    "View Picking Violated Feedback List",
  "general.lable.reopenedFeedbackList": "View Reopened Feedback List",
  "general.lable.reopenedReason": "Reopen Reason",
  "general.lable.newFeedbackList": "View New Feedback List",
  "general.lable.viewSLA": "View SLA",
  "general.lable.slaCondition": "SLA Conditions",
  "general.lable.pickUpTarget": "Pick Up Target",
  "general.lable.pickUpTargetTime": "Pick Up Target Time",
  "general.lable.oldFeedbacks": "Old Feedbacks",
  "general.lable.editTagUntage": "Edit Tag/Untag",
  "general.lable.unTagOldFeedback": "Untag Old Feedback",
  "general.lable.taggedBy": "Tagged By",
  "general.lable.feedbackId": "Feedback Id",
  "general.lable.plant": "Plant",
  "general.lable.resolvedComplaint": "Resolved Complaint",
  "general.lable.resolvedComplaintList": "View Resolved Complaint List",
  "general.lable.complaintSlaViolated": "Complaint SLA Violated",
  "general.lable.complaintSlaViolatedList": "View Complaint SLA Violated List",
  "general.lable.otherSlaViolated": "Others SLA Violated",
  "general.lable.othersSlaViolatedList": "View Others SLA Violated List",
  "general.lable.reopenedAndResolved": "Reopened And Resolved Complaint",
  "general.lable.reopenedAndResolvedList":
    "View Reopened And Resolved Complaint List",
  "general.msg.feedback.resolved": "Feedback has been resolved successfully",
  "general.lable.complaintRepeated": "Complaint Repeated",
  "general.lable.complaintRepeatedList": "View Complaint Repeated List",
  "general.lable.slaAlert": "SLA Alert",
  "general.lable.slaAlertList": "View SLA Alert List",
  "general.lable.EscNoOfRowsAlert": "More than 10 escalation level not allowed",
  "general.lable.errorMessage": "Something went to wrong",
  "general.lable.errorMessage.mappedDepartment":
    "Currently you are not mapped with any department. Please contact system administrator for further assistance.",
  "general.lable.message.searchInputsError":
    "Details requested are not found. Please provide more inputs to search accordingly.",
  "general.lable.message.noConsentFound": "No Consent Found",
  "general.lable.message.satisfiedFeedbackCode":
    "You have satisfied with feedback code",
  "general.lable.message.dropdown.satisfied": "SATISFIED",
  "general.lable.message.dropdown.notsatisfied": "NOT SATISFIED",
  "general.lable.message.registerFreshComplaint":
    "So it can't be reopened, it is requested to register a fresh complaint by tagging your previous feedback/complaint no.",
  "general.lable.message.nonSatisfied":
    "Thanks for your valuable feedback. Your feedback will be communicated to respective department and action will be taken accordingly.",
  "general.lable.message.satisfied":
    "Thanks for your valuable feedback. Your feedback will be communicated to respective department.",
  "general.lable.message.nonSatisfiedFeedbackCode":
    "We have found non-satisfaction reason as {0} for the feedback {1} already in the system. Hence action will be taken accordingly.",
  "general.lable.message.unTag": "Untag",
  "general.lable.message.tag": "Tag",
  "general.lable.message.confirmation": "Need Confirmation",
  "general.lable.message.confirmationMessage":
    "Are you sure you want to add feedback without uploading selected file?",
  "general.lable.message.uploadSelectedFile":
    "Please upload selected file before proceed.",
  "general.lable.message.dashboard":
    "All dashboard data are based on 3 months from current date.",
  "general.lable.message.dashboardCST":
    "All dashboard data are based on 3 months from current date by default.",
  "general.lable.message.dashboard.toDateAtMostCurrentDate":
    "To date can not be greater than current date !",
  "general.lable.message.dashboard.fromDateMaxThreeMonthsLessThanToDate":
    "From date can not be more than three months back from To date !",
  "general.button.message.text": "Go to Parent",
  "general.lable.message.feedbackAttachment": "Feedback Attachment List",
  "general.lable.message.responseAttachment": "Response Attachment List",
  "general.lable.message.notifications": "Notifications",
  "general.lable.message.toggleFullScreen": "Toggle Full-Screen",
  "general.lable.message.switchRole": "Switch Role",
  "general.lable.message.Role": "Role",
  "general.lable.message.openDashboardCriteriaPanel":
    "Open Dashboard Criteria Panel",
  "general.lable.gstNo.text": "GST No",
  "general.lable.userType.text": "User Type",
  "general.mobileNumber.empty": "Enter Mobile Number",
  "general.mobileNumber.Mobile": "Mobile",
  "general.phoneNumber.Phone": "Phone",
  "general.name.empty": "Enter Name",
  "general.exception.errorMessage.fileUpload":
    "Error occurred during file upload.",
  "general.exception.errorMessage.response.fileUpload":
    "Error occurred during survey response upload.",
  "general.exception.successMessage.response.fileUpload":
    "Survey response uploaded successfully.",
  "general.error.message.action.no.priviledged":
    "Sorry, it seems you don't have required privilege for this action.",
  "general.message.select.resolution.group":
    "Please select desired resolution target group.",
  "general.label.reffDocNo": "Reference Document No.",
  "general.tooltip.reffDocNo":
    "For quotation related issues, please mention RFQ No. For other issues please mention PO No.",
  "general.label.similarFeedbackCode":
    "Want to refer previous similar Feedback/Complaint?(Please type Feedback Code/Description/Date)",
  "general.lebel.closeFeedbackList": "View Close Feedback List",
  "general.error.feedbackDescription": "Please provide feedback description",
  "general.label.eventName": "Event/Item Name",
  "general.label.rfqNo": "RFQ No",
  "general.validation.empty.feedback.description":
    "Feedback description can not be empty",
  "feedback.user.email.empty": "User email can not be empty",
  "feedback.user.email.pattern.missmatch": "User email pattern found incorrect",
  "general.validation.empty.feedback.department.id":
    "Invalid department/service id found",
  "general.validation.empty.feedback.serviceMail.subject":
    "Invalid/no email subject found",
  "general.validation.empty.user": "User not found",
  "general.validation.unknown.department": "Department Unknown !!",
  "general.validation.unknown.error": "Error Occured !!",
  "general.validation.unknown.customer": "No customer selected.",
  "general.validation.select.customer": "Click To Select User",
  "general.label.customer.id": "Customer Id",
  "general.lable.user.select": "Select User",
  "general.validation.choose.customer": "Please select customer first !!",
  "general.label.clientOrDept": "Client/Department",
  "general.validation.input.invalid": "Found invalid input",
  "general.session.current-session.invalidated":
    "Current session successfully invalidated.",
  "general.label.text.pleaseChoose": "Please choose to",
  "general.session.invalidate.current-session": "Invalidate current session",
  "general.session.invalidate.previous-session": "Invalidate previous session",
  "general.message.additional.info.panel.header": "Additional Information",
  "general.message.additional.info.button.update":
    "Update additional information",
  "general.message.additional.info.minimum.input":
    "Please make sure minimum one input is given in additional information section first.",
  "general.message.additional.info.provide.attribute.prefix": "Please provide",
  "general.message.additional.info.provide.attribute.suffix":
    "in additional information section first.",
  "general.message.additional.info.save.attribute.confirmation.prefix":
    "Are you sure you want to update",
  "general.message.additional.info.save.attribute.confirmation.suffix":
    "in additional information.",
  "general.message.text.and": "and",
  "close.feedback.message.closure.mail.user.selection.panel.header":
    "Closure Mail User Selection",
  "close.feedback.message.closure.mail.user.selection.head.instruction":
    "Please select closure mail CC user(s)",
  "close.feedback.message.closure.mail.user.selection.empty.avail.user":
    "No more user available.",
  "close.feedback.message.closure.mail.user.selection.empty.selected.user":
    "Please drag user(s) from the panel in left.",
  "page.view.escalation.matrix.panel.main.head": "View Escalation Matrix",
  "page.view.escalation.matrix.panel.main.download":
    "Download Escalation Matrix",
  "page.edit.escalation.matrix.panel.main.head": "Edit Escalation Matrix",
  "page.edit.escalation.matrix.label.assignmentSlaMin": "Assignment SLA (Mins)",
  "page.edit.escalation.matrix.label.pickupSlaMin": "Pickup SLA (Mins)",
  "page.edit.escalation.matrix.label.resolutionSlaMin": "Resolution SLA (Mins)",
  "page.edit.escalation.matrix.label.resolverGroup": "Resolver Group(s)",
  "page.edit.escalation.matrix.title.blank.resolverGroup":
    "Please select a group",
  "page.edit.escalation.matrix.label.slaEscalation": "SLA Escalation",
  "page.edit.escalation.matrix.escalation.table.header.level":
    "Escalation Level",
  "page.edit.escalation.matrix.escalation.table.header.group":
    "Escalation Group",
  "page.edit.escalation.matrix.escalation.table.header.time":
    "Escalation Time(Mins)",
  "page.edit.escalation.matrix.escalation.table.header.user":
    "Escalation User(s)",
  "page.edit.escalation.button.label.updateSlaDetails": "Update SLA Details",
  "page.edit.escalation.button.label.bulkEdit": "Bulk Edit",
  "page.edit.escalation.button.label.updateEscalationDetails":
    "Update Escalation Details",
  "page.edit.escalation.field.error.pickupSla": "Please enter pickup SLA time",
  "page.edit.escalation.field.error.resolverGroup":
    "Please select resolver group",
  "page.edit.escalation.sla.update.success": "SLA details updated successfully",
  "page.edit.escalation.field.error.select.group.left":
    "Please select escalation group for escalation step no.",
  "page.edit.escalation.field.error.select.group.right": "",
  "page.edit.escalation.field.error.select.time.left":
    "Please enter escalation time for escalation step no.",
  "page.edit.escalation.field.error.select.time.right": "",
  "page.edit.escalation.matrix.data.missing":
    "Please provide at least one valid escalation group data",
  "page.edit.escalation.matrix.update.success":
    "Escalation level(s) updated successfully",
  "page.edit.escalation.error.no.more.step.left": "More than",
  "page.edit.escalation.error.no.more.step.right":
    "escalation level not allowed",
  "page.edit.escalation.field.error.select.time.whole-number.left":
    "Time for escalation step no.",
  "page.edit.escalation.field.error.time.whole-number.right":
    "should be positive whole number and greater than zero(0)",
  "page.view.master.area.panel.main.head": "View Master Area",
  "page.view.sub.area.panel.main.head": "View Sub Area",
  "page.add.master.area.panel.main.head": "Add Master Area",
  "page.add.sub.area.panel.main.head": "Add Sub Area",
  "page.modify.master.area.panel.main.head": "Edit Master Area",
  "page.modify.sub.area.panel.main.head": "Edit Sub Area",
  "page.view.master.area.id": "Master Area ID",
  "page.view.sub.area.id": "Sub Area ID",
  "page.view.master.group.id": "Assignee Group Id",
  "menu.key.master.group.name": "Group Name",
  "menu.key.master.targettime": "Target Time (DD-MM-YYYY HH:MM)",
  "menu.key.dashboard.list.targettime": "Target Time",
  "menu.key.dashboard.list.organisation.name": "Organization Name",
  "general.error.msg.unknown": "Something went wrong! Please Refresh",
  "general.label.serial.number.short": "Sr. No.",
  "page.view.master.group.panel.main.head": "Add Group by Type",
  "page.view.master.groupname.panel.main.head": "Add Group Name",
  "menu.key.master.group": "Assignee Group",
  "label.department.description": "Department Name",
  "label.master.area.description": "Master Area Description",
  "label.sub.area.description": "Sub Area Description",
  "general.label.areaOfConcern": "Area of Concern",
  "general.label.orderId": "Order Id",
  "general.label.itemId": "Item Id",
  "general.label.feedback.tag.dataDuration":
    "***Old feedback list data are based on last 90 days from current date.",
  "general.label.user.email.absence":
    "***Absence of email will not trigger system generated mail to customer",
  "general.label.feedback.tag.rating":
    "**Rating 1 to 3 consider as Not satisfied hence comment/reason required",
  "general.field.serviceUserId.validation.notEmpty": "No BU user id found",
  "general.field.department.id.validation.notEmpty": "No service id found",
  "general.tab.discardFeedback.text": "Discard Feedback",
  "alert.msg.discard.feedback.failed": "Feedback discard failed",
  "alert.msg.discard.feedback.success": "Feedback discarded successfully",
  "general.lable.discardedComment.text": "Discarded Comment",
  "general.label.discardComment.paceholder": "Please give reason !",
  "general.error.discardComment.confirm":
    "Are you sure you want to delete feedback?",
  "general.error.discardComment.required": "Discard comment is required",
  "general.label.required.comment": "Enter Your comment",
  "general.error.discardComment.length":
    "Discard comment can not be more than 500 character",
  "general.customer.oldCCHP": "Click here to visit old CCHP",
  "general.label.severity": "Severity",
  "general.label.plantCode": "Plant Code",
  "general.label.feedback.reassignment": "Feedback Reassignment",
  "general.label.feedback.reassign": "Reassign",
  "feedback.reassignment.confirmation.left":
    "Are you sure you want to reassign the feedback",
  "feedback.remove.confirmation.textQuestion": "Are you sure ?",
  "feedback.remove.confirmation.textPart1": "Are you sure want to remove ",
  "feedback.remove.confirmation.textPart2": "from the group",
  "feedback.reassignment.confirmation.right": "?",
  "error.msg.user.auth.not.found.or.self.or.customer":
    "User auth not found or self-auth found or customer-auth found",
  "general.label.reset.password": "Reset password",
  "general.label.removeUser.text": "User Removed Successfully",
  "general.label.addUser.text": "User added successfully",
  "reset.password.confirmation.left":
    "Are you sure you want to reset password for the user",
  "reset.password.confirmation.right": "?",
  "reset.password.success.msg": "Password reset successful",
  "reset.password.failure.msg": "Failed to reset password",
  "menu.key.survey.view": "View Survey",
  "menu.key.survey": "Survey",
  "title.new.surveyList.viewSurvey": "View Survey List",
  "label.new.surveyList.SLNo": "SR NO",
  "label.new.survey.surveyId": "Survey Id",
  "label.new.survey.surveyName": "Survey Name",
  "label.new.survey.surveyStartDate": "Survey Start Date",
  "general.tab.survey.surveyEndDate": "Survey End Date",
  "label.new.survey.avgScore": "Average Score",
  "label.new.survey.submitCount": "Submit Count",
  "label.new.survey.Action": "Action",
  "general.button.download": "Download",
  "general.button.viewDetails": "View Details",
  "button.label.survey.response.upload": "Upload response",
  "menu.key.survey.detail.view": "View survey detail",
  "label.new.survey.surveySubmitId": "Survey Submit Id",
  "label.new.survey.userName": "User Name",
  "label.new.survey.submitDate": "Submission Date",
  "general.tab.survey.score": "Score",
  "label.new.survey.result": "Result",
  "label.new.survey.status": "Status",
  "label.new.survey.answerId": "Answer Id",
  "label.new.survey.question": "Question",
  "label.new.survey.option": "Selected Option",
  "general.tab.survey.descrition": "Description",
  "general.label.filter.clear.button": "Reset Dashboard",
  "label.new.survey.remark": "Remark",
  "label.new.survey.taskforce": "Task Force",
  "label.new.survey.actionpoint": "Action Points",
  "label.new.survey.timeline": "Time Line",
  "label.new.survey.timeleft": "Time Left",
  "general.exception.successMessage.response.submit":
    "Survey response submitted successfully.",
  "general.exception.errorMessage.response.submit":
    "Error occurred during survey response submit.",
  "label.new.survey.organization": "Organization Name",
  "label.new.survey.noOfPassSurvey": "Passed Survey",
  "label.new.survey.noOfFailedSurvey": "Failed Survey",
  "general.label.tenderNo": "Tender No.",
  "general.label.userAdded": "User added successfully",
  "general.label.actionpoint.error": "Please provide your action point",
  "general.label.nodata.error": "No data to show",
  "general.label.assign.group": "Assign Group",
  "general.label.assign.group": "Assign Group",
  "general.label.dashboard.data":
    "At most 100 data are shown based on last 3 months from current date",
  "general.label.dashboard.hello": "Hello",
  "general.label.dashboard.greeting.text": "Greetings! have a wonderful day.",
  "general.label.analytics.dashboard": "Analytics Dashboard",
  "general.label.dashboard.button.addFeedback": "Complaint/Feedback",
  "general.label.dashboard.button.manage.my.history": "Manage my history",
  "general.label.dashboard.question.to.select.year":
    "Which year would you like to manage?",
  "general.label.to.do.list": "To-do List",
  "general.label.to.do.list.subject": "Subject",
  "general.label.take.note": "Take a note",
  "general.label.add.a.to.do": "Add To-do",
  "general.label.filter": "Filter",
  "general.label.apply.filter": "Apply Filter",
  "general.label.generate.new": "Generate New",
  "general.label.generate": "Generate",
  "general.label.apply": "Apply",
  "general.label.notagged.feedback": "No tagged feedback",
  "general.label.consent.feedback": "Consent/Comment",
  "general.label.customerResponse.feedback": "Enter customer response",
  "general.label.comment.details": "Comment Details",
  "general.label.add.comment": "Add a Comment",
  "general.label.no.comments": "No comments yet",
  "general.label.comment.submitted": "Comment submitted successfully!",
  "general.button.submitting.label": "Submitting...",
  "general.label.rate.now": "Rate Now",
  "general.label.rating": "Rating",
  "general.label.ongoing.complaint": "Most recent",
  "general.label.contact.info": "Contact Info",
  "general.label.history": "History",
  "general.label.attachment": "Attachment",
  "general.label.no.attachment": "No attachment",
  "general.label.subject": "Subject",
  "general.label.replied": "replied",
  "general.label.to": "To",
  "general.label.kb": "KB",
  "general.label.upload.complete": "Upload complete!",
  "general.label.calendar": "Calendar",
  "general.label.Clearall": "Clear all",
  "general.label.comment": "Please provide a comment",
  "general.label.resolver.noData": "No resolver details available",
  "general.label.reason.unsatisfaction":
    "Please enter the reason for unsatisfaction",
  "general.label.feedback.satisfaction":
    "Thank you for submitting your feedback satisfaction",
  "general.label.enter.reason": "Enter Reason",
  "general.label.tagged": "Tagged",
  "general.label.no.data.available": "No data available",
  "general.label.escalation.step": "Escalation Step",
  "general.label.escalation.seletedAreas":"Selected Area/Subarea",
  "general.label.assignee.name.group": "Assignee Name/Group",
  "general.label.escalation.time": "Escalation Time (DD-MM-YYYY HH:MM)",
  "general.label.no.slaDetails": "No SLA details available",
  "general.label.mandatory.fields": "Please fill all the mandatory fields",
  "general.label.feedback.code":
    "Feedback is added successfully. Feedback Code: ",
  "general.label.customer.response":
    "Response is added successfully.",
  "general.label.note.feedback.code":
    "  Please note down for future reference.",
  "general.label.feedback.required": "Feedback description is required.",
  "general.label.unfortunately.no.feedback.submit":
    "Unfortunately, could not submit feedback. ",
  "general.label.unfortunately.no.response.submit":
    "Unfortunately, could not submit response. ",
  "general.label.unfortunately.feedback.already.present.submit":
  "Feedback is already added for this callback request",
  "general.label.search.user": "Search User",
  "general.label.onlysimilarFeedbackCode":
    "Want to refer previous similar Feedback/Complaint?",
  "general.label.customer.org": "Customer Org.",
  "general.label.user.updated": "User updated successfully",
  "general.label.header.filled": "Please fill the text field",
  "general.label.modal.title": "Modal title",
  "general.label.escape.key":
    "I will not close if you click outside me. Do not even try to press escape key.",
  "general.label.Understood": "Understood",
  "general.label.feedback.info": "Feedback Information",
  "general.label.Success": "Success",
  "general.label.reopen.feedback": "Reopen Feedback",
  "general.label.tagged.feedback": "Tagged Feedback",
  "general.label.annually": "Annually",
  "general.label.3.months": "3 Months",
  "general.label.6.months": "6 Months",
  "general.label.custom.date": "Custom Date",
  "general.label.feedback": "Feedback",
  "general.label.complaint.status": "Complaint Status",
  "general.label.complaint.overall": "Overall Complaint",
  "general.label.feedback.overall": "Overall Feedback",
  "general.label.reviews.overall": "Overall Reviews",
  "general.label.greeting": "Greetings! have a wonderful day",
  "general.label.hello": "Hello",
  "general.label.feedback.general.query": "Feedback / General Query",
  "general.label.feedback.advance.filter": "Advance Filter",
  "general.label.Select.option": "Select an option",
  "general.label.Screen.resize": "Screen Resize",
  "general.label.language": "Language",
  "general.label.english": "English",
  "general.label.hindi": "Hindi",
  "general.label.login": "Login",
  "general.label.max.login": "Maximum sessions of 1 for this user exceeded",
  "general.label.logout.prevstate": "Logout from previous session",
  "general.label.logout.current": "Logout from this session",
  "general.label.feedback.closure.failed": "Feedback Closure Failed",
  "general.label.feedback.reopen.and.reassign": "Reopen & Reassign Feedback",
  "general.label.feedback.reassign": "Reassign Feedback",
  "general.label.bidder.organixation": "Bidder Organixation",
  "general.label.input.invalid": "Invalid input",
  "general.label.search.organisation": "Search Organisation",
  "general.label.enter.link": "Enter the URL of the link:",
  "general.label.untagged": "Feedback untagged successfully",
  "general.label.nofeedback": "No feedbacks for last three months",
  "general.label.view.all": "View all",
  "general.label.required": "Required",
  "general.label.native": "Native",
  "general.label.error": "Oops! Something went wrong.",
  "general.label.inconvenience.error": "We apologize for the inconvenience.",
  "general.label.go.home": "Go to Home",
  "general.label.log.out": "Log-out",
  "general.label.report.type": "Report Type",
  "general.label.overdue": "Overdue",
  "general.label.high.priority": "High Priority",
  "general.label.Medium.Priority": "Medium Priority",
  "general.label.Low.Priority": "Low Priority",
  "general.label.below": "below",
  "general.label.active": "Active",
  "general.label.accepted": "Accepted",
  "general.label.firstname.required": "First name is required",
  "general.label.lastname.required": "Last name is required",
  "general.label.email.required": "Invalid email address",
  "general.label.email.isrequired": "Email is required",
  "general.label.mobile.required": "Mobile number is required",
  "general.label.address.required": "Address is required",
  "general.label.mobile.invalid": "Invalid mobile number",
  "general.label.confirm": "Confirm",
  "general.label.add.authority": "Add more authority",
  "general.label.role": "the following role(s)?",
  "general.label.no.authority": "Are you sure you want to give no authority to",
  "general.label.fromdate.required": "From date is required",
  "general.label.option.menu": "Open this select menu",
  "general.label.role.switch": "Switch Role",
  "general.label.bidder.organization": "Bidder Organisation",
  "general.label.mobile.no": "Mobile No",
  "general.label.phone.no": "Phone No",
  "general.label.dept.id": "Department ID",
  "general.label.user.id": "User ID",
  "general.label.format": "Format",
  "general.label.Locale": "Locale",
  "general.label.download.excel.date": "Download Excel Data",
  "general.label.department.required": "Department is required",
  "general.label.Organization.required": "Organization name is required",
  "general.label.Invalid.PAN.number.format": "Invalid PAN number format",
  "general.label.Invalid.GST.number.format": "Invalid GST number format",
  "general.label.Select.user.type": "Select user type",
  "general.label.User.type.required": "User type is required",
  "general.label.Search.EmailId": "Search EmailId",
  "general.label.Search.Customer.Id": "Search Customer Id",
  "general.label.Search.Pan.No": "Search Pan No",
  "general.label.Search.Mobile.No": "Search Mobile No",
  "general.label.Search.Phone.No": "Search Phone No",
  "general.label.Search.Vendor.Code": "Search Vendor Code",
  "general.label.Status.required": "Status is required",
  "general.label.Consent.required": "Consent is required for",
  "general.label.user.list": "User List",
  "general.label.choose.file": "Choose File",
  "general.label.no.file.chosen": "No file chosen",
  "label.new.survey.timeleft": "Time Left",
  "label.general.navigation.back.to.complaint.list":
    "Back to Complaints/Feedbacks",
  "general.exception.errorMessage.feedbackDesc.correctiveaction":
    "Corrective action is required",
  "general.exception.errorMessage.feedbackDesc.preventiveaction":
    "Preventive action is required",
  "general.exception.errorMessage.feedbackDesc.rootcause":
    "Root cause is required",
  "general.exception.errorMessage.feedback.required":
    "Feedback type is required",
  "general.exception.errorMessage.feedback.source.required":
    "Feedback source is required",
  "min.letter.required": "Enter min {{num}} letter",
  "general.exception.errorMessage.comment.consentUser.required":
    "Consent user is required",
  "general.label.generic.queries": "Generic Queries",
  "general.label.search.queries": "Search your queries",
  "general.label.enter.verification.code": "Enter verification code",
  "general.label.resend.otp.in": "Resend OTP in",
  "general.label.resend.otp": "Resend Otp",
  "general.label.send.reply": "Send",
  "general.label.feedbackUpdates": "Feedback Updates",
  "general.description.feedback.update":
    "Provide an update to the feedback user",
  "mail.sent.success.message": "Mail has been sent successfully",
  "general.label.send.otp.success": "Otp sent Successfully",
  "chatbox.chatbot.greetings.message":
    "Greetings, How may I help you right now? Feel free to ask me anything!",
  "chatbox.agent.greeting.message.to.customer":
    "Hi {name} , How can I help you?",
  "chatbox.agent.no.customer.waitig":
    "Currently no customer waiting in the queue.",
  "chatbox.customer.queue.position":
    "Please wait for few minutes you are at position {{p}} in the queue.",
  "chatbox.customer.not.satisfied.text":
    "If your query is not answered properly you can talk to our customer representative or continue with the chat.",
  "chatbox.chat.with.agent": "Chat with agent",
  "chatbox.chat.with.bot.continue": "Continue",
  "chatbox.tooltip.customer": "Need Help?",
  "chatbox.tooltip.agent": "Chat Support",
  "chatbox.customer.callback.request.added":
    "Your callback request is under process. We will get in touch with you shortly",
  "chatbox.choose.desired.option": "How can we help you?",
  "chatbox.callback.comment.submitted": "Comment submitted successfully",
  "chatbox.callback.comment.submitted.unsuccessful":
    "Unfortunately comment submission failed. Please try again after some time",
  "chatbox.callback.comment.submitted.unsuccessful.msg":
    "Please submit new comment after {timeDiff} seconds of previous comment",
  "chatbox.callback.request.submit": "Request a callback",
  "chatbot.chat.with.bot": "Chat with bot",
  "chatbot.agent.delete.chat": "Delete Chat",
  "chatbox.user.ended.chat": "This chat has ended.",
  "chatbox.customer.end.chat": "End this chat",
  "chatbox.agent.end.user.chat": "End and remove chat",
  "chatbox.customer.end.chat.modal.body":
    "Are you sure you want to end this chat? Once deleted you have to start a new chat.",
  "chatbox.agent.end.chat.modal.body":
    "Are you sure you want to end and delete this chat? Make sure that the user's issue is resolved.",
  "chatbox.agent.end.chat.message":
  "Thanks for contacting us! We hope your issue has been resolved. If you need further assistance, we're always here.",
  "generel.lebel.cancel.confirmation": "Are you sure you want to cancel?",
  "chatbox.customer.chat.ended.message":
    "This chat has been ended. You can proceed with any of the following options.",
  "chatbox.customer.all.executives.busy.message":
    "We apologize for the wait. All of our customer executives are busy at the moment. You can try again later or give our support a call.",
  "customer.alert.message": "Our representative is available and ready to assist you. If there's nothing else you need at the moment, please feel free to end the discussion.",
  "chatbox.department.non.working.day.msg":"Thank you for reaching out to us. Please note that today is a non-working day, and our team is unavailable to assist you at the moment. We will respond to your query as soon as possible on the next working day. We appreciate your understanding and patience.",
  "chatbox.agent.out.of.office.msg" : "Thank you for contacting us. Our working hours are from {{startTime}} to {{stopTime}}. Our team is currently out of the office for the day. Please request for a chat during the next working day. We appreciate your understanding and patience.",
  "chatbox.rating.modal.heading": "Rate the Chatbot experience",
  "chatbox.rating.modal.message": "Please provide your rating before closing the chat.",
  "chatbox": {
    "support": {
      "contactSupport": "Contact Us", 
      "tollFreeNumber": "Support Toll-Free Number",
      "email": "Suppport Email"
    }
  },
  "menu.key.area.of.concern.report.id": "Report Id",
  "menu.key.area.of.concern.report.generated.by":"Generated By",
  "menu.key.area.of.concern.type":"Area of Concern",
  "menu.key.area.of.concern.date.of.generation": "Date Of Generation",
  "menu.key.area.of.concern.top.count" :"Top Count",
  "area.of.concern.issue.count" : "Issue Count",
  "area.of.concern.root.cause" : "Root Cause",
  "area.of.concern.proposed.solution" : "Proposed Solution",
  "area.of.concern.process.implemented" : "Process Implemented",
  "area.of.concern.target.closure.date" : "Closure date",
  "area.of.concern.area.name" : "Area",
  "area.of.concern.subarea.name" : "Sub-Area",
  "area.of.concern.generate.success" : "Report generated successfully",
  "alert.msg.department.attribute.fail": "Please fill up all mandatory fields before saving !!",
  "label.new.survey.mandatoryFieldValidation": "All mandatory fields must be filled.",
  "label.survey.expired.message": "Survey has Ended",
};